var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnregungen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,16.8c15.4,0,26.6,10.5,26.6,24.9c0,13.5-8.9,25.5-20.2,28.9V52.1l1.2,0.9c0.6,0.4,1.3,0.4,1.9,0l4.3-3.2 c0.7-0.5,0.9-1.6,0.4-2.3c-0.5-0.7-1.5-0.9-2.3-0.4l-3.4,2.5l-3.4-2.5c-0.6-0.4-1.3-0.4-1.9,0L50,49.5l-3.4-2.5 c-0.6-0.4-1.3-0.4-1.9,0l-3.4,2.5l-3.3-2.5c-0.7-0.5-1.7-0.4-2.3,0.4c-0.5,0.7-0.4,1.8,0.3,2.3c0,0,0,0,0,0l4.3,3.2 c0.6,0.4,1.3,0.4,1.9,0l1.2-0.9v18.6c-11.3-3.4-20.2-15.5-20.2-28.9C23.4,27.2,34.6,16.8,50,16.8 M46.7,51.2l2.4,1.8 c0.6,0.4,1.3,0.4,1.9,0l2.4-1.8c-0.1,0.2-0.1,0.3-0.1,0.5v19.7c-2.1,0.4-4.3,0.4-6.4,0V51.7C46.8,51.5,46.7,51.3,46.7,51.2  M60.1,83.2H39.9l-3.7-12.4c8.4,5.4,19.1,5.4,27.6,0L60.1,83.2z M54.8,96.5h-9.7c-2,0-3.9-1.3-4.6-3.3h18.8 C58.7,95.2,56.9,96.5,54.8,96.5 M59.7,89.9H40.3v-3.3h19.3V89.9z M20.2,41.7c0.1,10,4.3,19.5,11.7,26l5.2,17.5v6.4 c0,4.6,3.6,8.3,8.1,8.3h9.7c4.4,0,8.1-3.7,8.1-8.3v-6.4l5.2-17.5c7.4-6.5,11.6-16,11.7-26c0-16.4-12.5-28.3-29.8-28.3 C32.7,13.4,20.2,25.3,20.2,41.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,48.7c0.2,0.8,0.8,1.3,1.6,1.3c0.1,0,0.2,0,0.4,0c0.9-0.2,1.4-1.1,1.2-2v0c-1.6-6.1-0.3-12.7,3.5-17.7 c3.5-4.4,8.8-7,14.3-6.9c0.9,0,1.6-0.7,1.6-1.7c0-0.9-0.7-1.7-1.6-1.7C41.9,20,35.7,23,31.6,28.2C27.2,34,25.7,41.6,27.5,48.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,23.4h1.6c0.9,0,1.6-0.7,1.6-1.7c0-0.9-0.7-1.7-1.6-1.7h-1.6c-0.9,0-1.6,0.7-1.6,1.7 C51.6,22.7,52.3,23.4,53.2,23.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6,8.4V1.8c0-0.9-0.7-1.7-1.6-1.7c-0.9,0-1.6,0.7-1.6,1.7v6.6c0,0.9,0.7,1.7,1.6,1.7 C50.9,10.1,51.6,9.4,51.6,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7,75.4c-0.6,0.6-0.6,1.7,0,2.3l4.8,5c0.6,0.6,1.7,0.6,2.3,0c0.6-0.6,0.6-1.7,0-2.3l-4.8-5 C76.3,74.8,75.3,74.8,74.7,75.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,10.6c-0.6-0.6-1.7-0.6-2.3,0c-0.6,0.6-0.6,1.7,0,2.3l4.8,5c0.6,0.6,1.7,0.6,2.3,0c0.6-0.6,0.6-1.7,0-2.3 L14.1,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2,82.8c0.6,0.6,1.6,0.6,2.3,0l4.8-5c0.6-0.7,0.6-1.7,0-2.3c-0.6-0.6-1.6-0.6-2.2,0l-4.8,5 C17.8,81,18.1,82,18.2,82.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,50c0,0.9,0.7,1.7,1.6,1.7h8.1c0.9,0,1.6-0.7,1.6-1.7s-0.7-1.7-1.6-1.7H8.1C7.2,48.3,6.5,49.1,6.5,50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9,10.6l-4.8,5c-0.6,0.6-0.7,1.7,0,2.3c0.6,0.7,1.6,0.7,2.3,0c0,0,0,0,0,0l4.8-5c0.6-0.7,0.6-1.7,0-2.3 C87.6,10,86.6,10,85.9,10.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2,50c0,0.9,0.7,1.7,1.6,1.7h8.1c0.9,0,1.6-0.7,1.6-1.7s-0.7-1.7-1.6-1.7h-8.1C83,48.3,82.2,49.1,82.2,50"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnregungen);
export default __webpack_public_path__ + "static/media/Anregungen.7d437b0fd99cc780068ecfaaacdff955.svg";
export { ForwardRef as ReactComponent };